import React from 'react';
import ContentLoader from "react-content-loader"
import {connect} from "react-redux";
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {resetUserFriend, updateUserFriend} from "../../../../creators/user.friend";

import Avatar from '../../Avatar';
import DateSince from '../../Date';
import createLink from "../../../../libs/createLink";
import {Button} from "../../Button";
import {isNoFollowProfil} from "../../../../libs/helper";

class AddFriendToChat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdded: this.props.isFavourite,
            loading: false,
        };
    }

    componentWillUnmount() {
        this.setState({isAdded: false});
    }

    render() {
        let relLinkProfil = {};
        if(this.props.userFriendsInitialized){
            relLinkProfil = isNoFollowProfil(this.props) ? { rel: "nofollow" } : {};
        }

        return !this.props.userFriendsInitialized ? (
            <ContentLoader
                ariaLabel={false}
                height={60}
                width={260}
                speed={2}
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
            >
                <rect x="72" y="17" rx="4" ry="4" width="117" height="6.4"/>
                <rect x="72" y="37" rx="3" ry="3" width="85" height="6.4"/>
                <circle cx="29.4" cy="29.81" r="26.4"/>
                <rect x="257.78" y="40.61" rx="0" ry="0" width="0" height="0"/>
                <circle cx="247.8" cy="28.63" r="8.02"/>
            </ContentLoader>
        ) : (
            <div className="friends">
                <Link to={this.props._id ? createLink('userProfile', this.props) : "/"} {...relLinkProfil}>
                    <Avatar avatar={this.props.profile && (this.props.profile.avatar || "")}
                            gender={this.props.profile && this.props.profile.gender} alt=""/>
                </Link>
                <div className="infos-user-wrapper">
                    <Link to={this.props._id ? createLink('userProfile', this.props) : "/"} {...relLinkProfil}>
                        <div className="username">{this.props.username || ""}</div>
                    </Link>
                    <div
                        className={`status-dot small-dot full text small medium-grey ${this.props.online ? "online" : "offline"}`}>
                        {this.props.online ? "Connecté" : (
                            <DateSince
                                date={this.props.lastVisit}
                                prefix={false}
                                currentFormat={true}
                            />
                        )}
                    </div>
                </div>
                <div className="options add-to-chat">
                    {!this.props.usersIds.includes(this.props._id) ? (
                        <Button size={"small"}
                                btnStyle={"primary-reverse"}
                                onClick={() => this.props.handleAddUser(this.props._id)}
                                loading={this.props.userFriendsSubmitting}
                                content={"Ajouter"} />
                    ) : (
                        <Button disabled={true}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                icon={"check"}
                                iconSide={"right"}
                                content={"Ajouté"} />
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFriendsSubmitting: state.userFriends.submitting,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetUserFriend,
    updateUserFriend,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AddFriendToChat);